import { useQuery } from '@tanstack/react-query';
import { fetchTagsData, type FetchTagsDataRequest } from '@/utils/tagsAPI';
import type { TagData } from '@/components/reports/tags/types';

export function useTagsData(request: FetchTagsDataRequest | null) {
  return useQuery<TagData, Error>({
    queryKey: ['tagsData', request],
    queryFn: () => {
      if (!request) {
        throw new Error('Request is required');
      }
      return fetchTagsData(request);
    },
    enabled: !!request && !!request.tagId && request.periods.length > 0 && !!request.totalPages,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}
